import React, { useEffect, useState } from "react";
import {
  APIFILTERLIST,
  APPLICABLE_ROLE,
  DEFAULT_DASHBOARD_PAYLOAD,
  HEADERLIST,
  SELECTEDFILTERTITLE,
  HEADER_FILTER_TYPE,
  STATUS_FILTER,
  TELECONSULT_FILTER_MENU,
  INCLINIC_FILTER_MENU,
  CONSULTATIONTYPE,
  dateFilter,
  getDateByRanges,
  DASHBOARD_VIEW,
  PRESCRIPTION_FILTER_ITEMS,
} from "../../Constant";
import moment from "moment";
import "./dashboardAppointmentsViewTable.scss";
import DashboardFilterIcon from "../../../../assets/newIcn.png";
import NoDataFound from "../../../../assets/Nodata.svg";
import SelectDoctor from "../../../../assets/selectDoctor.svg";
import {
  addQuery,
  removeDashboardFilterFromLocalStorage,
  removeQuery,
} from "../../Helper";
import FilterMenuList from "../../../common/Modules/FilterMenuList";
import { useLocation, useHistory } from "react-router-dom";
import DatePicker from "../../../common/Modules/DatePicker";
import DashboardAppointmentsViewTableHeader from "./DashboardAppointmentsViewTableHeader";
import DashboardAppointmentsViewTableCell from "./DashboardAppointmentsViewTableCell";
import { ClickAwayListener } from "@material-ui/core";
import CustomisedChip from "../../../common/Modules/CustomisedChip";
import CustomisedMobileFilter from "../../../common/Modules/CustomisedMobileFilter";
import TitleSubtitleCard from "../../../common/Modules/TitleSubtitleCard";
import RadioButtonWithText from "../../../common/Modules/RadioButtonWithText";
import Loader from "../../../../assets/C2C Loader.gif";
import MobileFilterWithDatePicker from "../../../common/Modules/MobileFilterWithDatePicker";
import { DateRangePicker } from "react-date-range";
import NoDataComponent from "../../../common/NoDataUI/NoDataComponent";
import DashboardAppointmentsTableQueueHeader from "./DashboardAppointmentsTableQueueHeader";
import MultiSelectChips from "../../../common/Modules/MultiSelectChip";
import { USER_ROLE } from "../../../../Util/constants";

const DashboardAppointmentsViewTable = (props) => {
  const {
    dashboardAppointmentsData,
    selectedFilters,
    consultation_type,
    consultation_filter,
    status_filter,
    doctor_name_filter,
    contentLoading,
    selected_doctor,
    user_type,
    doctorRole,
    user_id,
    clinic_id,
    staff_id,
    page_no,
    showMobileFilter,
    showDownloadMobileFilter,
    statusCountHeader,
    selectedStatusCard,
    paymentMethodHeader,
    app_start_date,
    procedures,
    consultationWiseDoctors,
    doctorClinicAssociation,
    checkedInAppnt,
    doctorIds,
    socketResponse,
    handleRefreshApi,
    handleCloseMobileFilter,
    handleStatusCard,
    handlePaymentMethod,
    onRescheduleAppnt,
    callNextAppointmentWidget,
    callDashboardAppointmentsApi,
    downloadCallback,
    statusCountHeaderQueue,
    selectQueueDoctor,
    viewType,
    appointmentListQueueView,
    paymentMethodHeaderQueue,
    handleStatusCardQueue,
    handlePaymentMethodQueue,
    showMobileFilterQueue,
    handleCloseMobileFilterQueue,
    isUhidEnabled,
  } = props;
  const history = useHistory();
  const location = useLocation();

  const [selected_header_item, setSelectedHeaderItem] = useState(null);
  const [applicableHeaderList, setApplicableHeaderList] = useState([]);
  const [showMobFilter, setShowMobFilter] = useState(false);
  const [showDownloadMobFilter, setShowDownloadMobFilter] = useState(false);
  const [showModalForScheduleFollowUp, setShowModalForScheduleFollowUp] =
    React.useState(false);
  const [showMobFilterQueue, setShowMobFilterQueue] = useState(false);
  const [applicableHeaderListQueue, setApplicableHeaderListQueue] = useState(
    []
  );

  const [dashboardHeaderList, setDashboardHeaderList] = useState([
    {
      id: 1,
      title: HEADERLIST.PATIENTDETAILS,
      applicable_roles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
    },
    {
      id: 2,
      title: HEADERLIST.DOCTORNAME,
      mobileFilterTitle: HEADERLIST.DOCTORNAME,
      filter_icon: DashboardFilterIcon,
      filter_type: HEADER_FILTER_TYPE.DOCTORNAME,
      show_filter: false,
      menuData: [],
      applicable_roles: [
        USER_ROLE.DOCTOR_ADMIN,
        APPLICABLE_ROLE.STAFF,
        USER_ROLE.RESOURCE_ADMIN,
      ],
      show_filter_searchbar: true,
      placeholderForSearch: "Search Doctor",
    },
    {
      id: 3,
      title: HEADERLIST.CONSULTATION,
      mobileFilterTitle: HEADERLIST.CONSULTATION,
      filter_icon: DashboardFilterIcon,
      filter_type: HEADER_FILTER_TYPE.CONSULTATION,
      show_filter: false,
      menuData: [],
      applicable_roles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
      show_filter_searchbar: true,
      placeholderForSearch: "Search for Procedure",
    },
    {
      id: 4,
      title: HEADERLIST.STATUS,
      mobileFilterTitle: HEADERLIST.STATUS,
      filter_icon: DashboardFilterIcon,
      filter_type: HEADER_FILTER_TYPE.NORMAL,
      show_filter: false,
      menuData: STATUS_FILTER,
      applicable_roles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
    },
    {
      id: 5,
      title: HEADERLIST.DATETIME,
      show_filter: false,
      applicable_roles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
    },
    {
      id: 6,
      title: "",
      applicable_roles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
    },
    {
      id: 7,
      title: HEADERLIST.PRESCRIPTION,
      mobileFilterTitle: HEADERLIST.PRESCRIPTION,
      filter_icon: DashboardFilterIcon,
      filter_type: HEADER_FILTER_TYPE.NORMAL,
      show_filter: false,
      menuData: PRESCRIPTION_FILTER_ITEMS,
      applicable_roles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
    },
  ]);

  const dashboardDownloadHeaderList = [
    {
      id: 1,
      title: HEADERLIST.DATETIME,
      filter_type: HEADER_FILTER_TYPE.DATE,
      mobileFilterTitle: HEADERLIST.MOBILEDATE,
      show_filter: false,
      applicable_roles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
    },
  ];
  const [consultationList, setConsultationList] = useState([]);
  const [doctorFilterList, setDoctorFilterList] = useState([]);
  const [doctorFilterListQueue, setDoctorFilterListQueue] = useState([]);
  const [selectionRange, setSelectionRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    dateDisplayFormat: "DD MMM YYYY",
    rangeColors: "#F969A4",
    color: "#F969A4",
    key: "selection",
  });
  const [selected_queue_item, setSelectedQueueItem] = useState(null);
  const [dashboardHeaderListQueue, setDashboardHeaderListQueue] = useState([
    {
      id: 1,
      title: HEADERLIST.PATIENTDETAILS,
      applicable_roles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
    },
    {
      id: 2,
      title: HEADERLIST.DOCTORNAME,
      mobileFilterTitle: HEADERLIST.DOCTORNAME,
      filter_icon: DashboardFilterIcon,
      filter_type: HEADER_FILTER_TYPE.DOCTORNAME,
      show_filter: false,
      menuData: [],
      applicable_roles: [
        USER_ROLE.DOCTOR_ADMIN,
        APPLICABLE_ROLE.STAFF,
        USER_ROLE.RESOURCE_ADMIN,
      ],
      className: "doctorList",
      isMultiSelect: true,
      showApplyResetBtn: true,
      show_filter_searchbar: true,
      placeholderForSearch: "Search Doctor",
    },
    {
      id: 3,
      title: HEADERLIST.CONSULTATION,
      mobileFilterTitle: HEADERLIST.CONSULTATION,
      filter_type: HEADER_FILTER_TYPE.CONSULTATION,
      show_filter: false,
      menuData: [],
      applicable_roles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
      show_filter_searchbar: true,
    },
    {
      id: 4,
      title: HEADERLIST.STATUS,
      mobileFilterTitle: HEADERLIST.STATUS,
      filter_type: HEADER_FILTER_TYPE.NORMAL,
      show_filter: false,
      menuData: STATUS_FILTER,
      applicable_roles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
    },
    {
      id: 5,
      title: HEADERLIST.DATETIME,
      show_filter: false,
      applicable_roles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
    },
    {
      id: 6,
      title: "",
      applicable_roles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
    },
  ]);

  const [selectedQueueDoctorList, setSelectedQueueDoctorList] = useState([]);
  const [selectedQueueDoctor, setSelectedQueueDoctor] = useState({});

  // localstorage data
  const lsSelectedQueueDoctorList = localStorage.getItem(
    "lsSelectedQueueDoctorList"
  );
  const lsSelectedQueueDoctor = localStorage.getItem("lsSelectedQueueDoctor");

  // Life Cycle methods ==>

  // To set the selected doctor filter
  useEffect(() => {
    let arr = [],
      docIds = [];
    if (consultationWiseDoctors) {
      consultationWiseDoctors.forEach((da) => {
        if (!docIds.includes(da.doctor_id)) {
          docIds.push(da.doctor_id);
        }
      });
    }
    if (selected_doctor) {
      arr.push({
        name: "All",
        value: "all",
        doctor_name: "all",
        selected:
          !doctor_name_filter || doctor_name_filter.toLowerCase() === "all"
            ? true
            : false,
      });
      selected_doctor.forEach((doc) => {
        if (docIds.includes(doc.doctor_id)) {
          arr.push({
            ...doc,
            selected:
              doctor_name_filter && doctor_name_filter === doc.doctor_id
                ? true
                : false,
          });
        }
      });
      dashboardHeaderList.forEach((hl) => {
        if (hl.title === HEADERLIST.DOCTORNAME) {
          hl.menuData = arr;
          hl.placeholderForSearch = getPlaceholder();
        }
        if (hl.title === HEADERLIST.PRESCRIPTION) {
          hl.applicable_roles = [];
        }
      });
      setDashboardHeaderList([...dashboardHeaderList]);
    }
  }, [consultationWiseDoctors, selected_doctor, doctor_name_filter]);

  // useEffect for doctorList in Queue view
  useEffect(() => {
    let queueDoctorList = [];
    if (!socketResponse) {
      if (lsSelectedQueueDoctorList && lsSelectedQueueDoctor) {
        let parsedData = JSON.parse(lsSelectedQueueDoctorList);
        let parsedDoctorData = JSON.parse(lsSelectedQueueDoctor);
        setSelectedQueueDoctorList(parsedData);
        setSelectedQueueDoctor(parsedDoctorData);
        selectQueueDoctor(parsedDoctorData.doctor_id);
        queueDoctorList = parsedData.map((a) => a.doctor_id);
      }
      let arr = [];
      if (selected_doctor) {
        selected_doctor.forEach((doc) => {
          arr.push({
            ...doc,
            selected: queueDoctorList.includes(doc?.doctor_id) ? true : false,
          });
        });
        dashboardHeaderListQueue.forEach((hl) => {
          if (hl.title === HEADERLIST.DOCTORNAME) {
            hl.menuData = arr;
            hl.placeholderForSearch = getPlaceholder();
          }
        });
        setDashboardHeaderListQueue([...dashboardHeaderListQueue]);
      }
    }
  }, [socketResponse, selected_doctor, viewType]);

  useEffect(() => {
    if (
      (doctorRole === USER_ROLE.DOCTOR_CONSULTANT ||
        doctorRole === USER_ROLE.RESOURCE_CONSULTANT ||
        !clinic_id) &&
      user_type !== "staff"
    ) {
      setSelectedQueueDoctor({
        doctor_id: user_id,
        name: localStorage.getItem("doctorName"),
      });
      selectQueueDoctor(user_id);
      setSelectedQueueDoctorList([]);
    }
  }, [clinic_id, viewType]);

  useEffect(() => {
    let selectedFilter = consultation_filter
      ? consultation_filter
      : DEFAULT_DASHBOARD_PAYLOAD.consultation_filter;
    let arr = [];

    if (consultation_type === CONSULTATIONTYPE.INCLINIC) {
      arr.push({
        name: "All",
        value: "all",
        selected:
          !selectedFilter || selectedFilter.toLowerCase() === "all"
            ? true
            : false,
      });
      if (
        doctorRole !== USER_ROLE.RESOURCE_CONSULTANT &&
        doctorRole !== USER_ROLE.RESOURCE_ADMIN
      ) {
        INCLINIC_FILTER_MENU.forEach((con) => {
          arr.push({
            ...con,
            selected:
              selectedFilter && selectedFilter === con.value ? true : false,
          });
        });
      }
      procedures &&
        procedures.forEach((pro) => {
          arr.push({
            ...pro,
            selected:
              selectedFilter && selectedFilter === pro.value ? true : false,
          });
        });
    } else if (consultation_type === CONSULTATIONTYPE.ONLINE) {
      arr.push({
        name: "All",
        value: "all",
        selected:
          !selectedFilter || selectedFilter.toLowerCase() === "all"
            ? true
            : false,
      });
      TELECONSULT_FILTER_MENU.forEach((tele) => {
        arr.push({
          ...tele,
          selected:
            selectedFilter && selectedFilter === tele.value ? true : false,
        });
      });
    }
    dashboardHeaderList.forEach((hl) => {
      if (hl.title === HEADERLIST.CONSULTATION) {
        hl.menuData = arr;
      }
    });
    setDashboardHeaderList([...dashboardHeaderList]);
  }, [consultation_type, consultation_filter, procedures]);

  // To set the selected status filter
  useEffect(() => {
    let selectedFilter = status_filter
      ? status_filter
      : DEFAULT_DASHBOARD_PAYLOAD.status_filter;
    dashboardHeaderList.forEach((list) => {
      if (list.title === HEADERLIST.STATUS) {
        list.menuData.map(
          (menu) =>
            (menu.selected = menu.value === selectedFilter ? true : false)
        );
      }
    });
    setDashboardHeaderList([...dashboardHeaderList]);
  }, [status_filter]);

  useEffect(() => {
    setShowMobFilter(showMobileFilter);
    if (showMobileFilter) {
      dashboardHeaderList.forEach((hl) => {
        if (hl.title === HEADERLIST.PRESCRIPTION) {
          hl.applicable_roles = [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF];
        }
      });
      let headerList = dashboardHeaderList.filter(
        (li) =>
          li.applicable_roles.indexOf(user_type) !== -1 ||
          li.applicable_roles.indexOf(doctorRole) !== -1
      );
      let list = [];
      headerList.map((menu) => menu.filter_icon && list.push(menu));
      list.forEach((li, ind) => {
        li.show_filter = false;
        if (ind === list.length - 1) {
          li.show_filter = true;
          handleMobileSelectedItem(li);
        }
        li.menuData &&
          li.menuData.forEach((menu, indM) => {
            menu.selected = indM === 0 ? true : false;
          });
      });
      setApplicableHeaderList([...list]);
    }
  }, [showMobileFilter]);

  useEffect(() => {
    setShowDownloadMobFilter(showDownloadMobileFilter);
    if (showDownloadMobileFilter) {
      dashboardDownloadHeaderList.forEach((li, ind) => {
        li.show_filter = false;
        if (ind === dashboardDownloadHeaderList.length - 1) {
          li.show_filter = true;
          handleMobileSelectedItem(li);
        }
        if (li.mobileFilterTitle === HEADERLIST.MOBILEDATE) {
          li.menuData = dateFilter;
        }
        li.menuData &&
          li.menuData.forEach((menu, indM) => {
            menu.selected = indM === 0 ? true : false;
          });
      });
      setApplicableHeaderList([...dashboardDownloadHeaderList]);
    }
  }, [showDownloadMobileFilter]);

  useEffect(() => {
    setShowMobFilterQueue(showMobileFilterQueue);
    if (showMobileFilterQueue) {
      let headerList = dashboardHeaderListQueue.filter(
        (li) =>
          li.applicable_roles.indexOf(user_type) !== -1 ||
          li.applicable_roles.indexOf(doctorRole) !== -1
      );
      let list = [];
      headerList.map((menu) => menu.filter_icon && list.push(menu));
      list.forEach((li, ind) => {
        li.show_filter = false;
        if (ind === list.length - 1) {
          li.show_filter = true;
          handleMobileSelectedItem(li);
        }
      });
      setApplicableHeaderListQueue([...list]);
    }
  }, [showMobileFilterQueue]);

  useEffect(() => {
    if (viewType) {
      for (const el of dashboardHeaderList) {
        //closing all list filters on changing viewtype
        el.show_filter = false;
      }
      for (const el of dashboardHeaderListQueue) {
        //closing all queue filters on changing viewtype
        el.show_filter = false;
      }
      if (viewType === DASHBOARD_VIEW.LIST) {
        setSelectedQueueDoctor({});
        setSelectedQueueDoctorList([]);
        let index = dashboardHeaderListQueue.findIndex(
          (list) => list.title === HEADERLIST.DOCTORNAME
        );
        dashboardHeaderListQueue[index].menuData.map(
          (data) => (data.selected = false)
        );
        setDashboardHeaderListQueue([...dashboardHeaderListQueue]);
      } else {
        removeQuery(history, location, [APIFILTERLIST.PRESCRIPTION_FILTER]);
      }
    }
  }, [viewType]);

  // <==

  // Helper methods ==>

  const getPlaceholder = () => {
    return doctorRole?.includes("resource")
      ? "Search Resource"
      : "Search Doctor" +
          (doctorRole === USER_ROLE.DOCTOR_ADMIN &&
          consultation_type === CONSULTATIONTYPE.INCLINIC
            ? "/Resource"
            : "");
  };

  const appendFilterToUrl = (item) => {
    let key = "",
      value = "",
      add = false,
      val = selected_header_item;
    if (val.title === HEADERLIST.CONSULTATION) {
      key = [
        APIFILTERLIST.CONSULTATION,
        APIFILTERLIST.IS_PROCEDURE,
        APIFILTERLIST.PAGENO,
      ];
      let checkIsProcedure = item?.type === "default" ? false : true;
      value = [item.value, checkIsProcedure, DEFAULT_DASHBOARD_PAYLOAD.page_no];
      add = item.value !== DEFAULT_DASHBOARD_PAYLOAD.consultation_filter;
    } else if (val.title === HEADERLIST.STATUS) {
      key = [APIFILTERLIST.STATUS, APIFILTERLIST.PAGENO];
      value = [item.value, DEFAULT_DASHBOARD_PAYLOAD.page_no];
      add = item.value !== DEFAULT_DASHBOARD_PAYLOAD.appointment_status_filter;
    } else if (val.title === HEADERLIST.DOCTORNAME) {
      key = [
        APIFILTERLIST.DOCTORNAME,
        APIFILTERLIST.DOCTOR_NAME,
        APIFILTERLIST.PAGENO,
      ];
      value = [item.doctor_id, item.name, DEFAULT_DASHBOARD_PAYLOAD.page_no];
      add = item.doctor_id ? true : false;
    } else if (val.title === HEADERLIST.PRESCRIPTION) {
      key = [APIFILTERLIST.PRESCRIPTION_FILTER, APIFILTERLIST.PAGENO];
      value = [item.value, DEFAULT_DASHBOARD_PAYLOAD.page_no];
      add = item.value !== undefined ? true : false;
    }

    if (add) {
      addQuery(history, location, key, value);
    } else {
      removeQuery(history, location, key);
    }
  };

  // <===

  // Actions ==>

  const openMenuList = (val) => {
    let index = dashboardHeaderList.findIndex((list) => list.id === val.id);
    if (val.filter_type === HEADER_FILTER_TYPE.CONSULTATION) {
      setConsultationList(dashboardHeaderList[index].menuData);
    }
    if (val.filter_type === HEADER_FILTER_TYPE.DOCTORNAME) {
      setDoctorFilterList(dashboardHeaderList[index].menuData);
    }
    dashboardHeaderList[index].show_filter =
      !dashboardHeaderList[index].show_filter;

    setDashboardHeaderList([...dashboardHeaderList]);
    setSelectedHeaderItem(val);
  };

  const openQueueMenuList = (val) => {
    let index = dashboardHeaderListQueue.findIndex(
      (list) => list.id === val.id
    );
    if (val.filter_type === HEADER_FILTER_TYPE.DOCTORNAME) {
      setDoctorFilterListQueue(dashboardHeaderListQueue[index].menuData);
    }
    dashboardHeaderListQueue[index].show_filter =
      !dashboardHeaderListQueue[index].show_filter;
    if (val.filter_type === HEADER_FILTER_TYPE.DOCTORNAME) {
      if (dashboardHeaderListQueue[index].show_filter) {
        dashboardHeaderListQueue[index].menuData.forEach((ele) => {
          ele.selected = false;
          let ind = selectedQueueDoctorList.findIndex(
            (item) => item.doctor_id === ele.doctor_id
          );
          if (ind !== -1) {
            ele.selected = true;
          }
        });
      }
      setDoctorFilterListQueue(dashboardHeaderListQueue[index].menuData);
    }

    setDashboardHeaderListQueue([...dashboardHeaderListQueue]);
    setSelectedQueueItem(val);
  };

  const toggleItems = (item) => {
    let val = selected_header_item;
    let index = dashboardHeaderList.findIndex((list) => list.id === val.id);
    dashboardHeaderList[index].show_filter = false;
    let index1 = dashboardHeaderList[index].menuData.indexOf(item);
    dashboardHeaderList[index].menuData.map((data) => (data.selected = false));
    dashboardHeaderList[index].menuData[index1].selected = true;
    setDashboardHeaderList([...dashboardHeaderList]);
    appendFilterToUrl(item);
  };

  const toggleQueueItems = (item) => {
    let val = selected_queue_item;
    let index = dashboardHeaderListQueue.findIndex(
      (list) => list.id === val.id
    );
    let index1 = dashboardHeaderListQueue[index].menuData.indexOf(item);
    dashboardHeaderListQueue[index].menuData[index1].selected =
      !dashboardHeaderListQueue[index].menuData[index1].selected;
    setDashboardHeaderListQueue([...dashboardHeaderListQueue]);
  };

  const applyRange = (range) => {
    appendFilterToUrl([
      moment(range.startDate).format("YYYY-MM-DD"),
      moment(range.endDate).format("YYYY-MM-DD"),
    ]);
    closeDatePicker();
  };

  const closeDatePicker = () => {
    dashboardHeaderList.forEach((hl) => {
      if (hl.title === HEADERLIST.DATETIME) {
        hl.show_filter = false;
      }
    });
    setDashboardHeaderList([...dashboardHeaderList]);
  };

  const handleClose = (item) => {
    let index = dashboardHeaderList.findIndex((list) => list.id === item.id);
    dashboardHeaderList[index].show_filter = false;
    if (dashboardHeaderList[index].title === HEADERLIST.DOCTORNAME) {
      dashboardHeaderList[index].menuData = doctorFilterList;
    }
    setDashboardHeaderList([...dashboardHeaderList]);
  };

  const handleMobileSelectedItem = (val) => {
    setSelectedHeaderItem(val);
  };

  const openMobileMenuList = (val) => {
    applicableHeaderList.forEach((dh) => {
      dh.show_filter = false;
    });
    let index = applicableHeaderList.findIndex((list) => list.id === val.id);
    applicableHeaderList[index].show_filter = true;
    if (val.filter_type === HEADER_FILTER_TYPE.CONSULTATION) {
      setConsultationList(applicableHeaderList[index].menuData);
    }
    if (val.filter_type === HEADER_FILTER_TYPE.DOCTORNAME) {
      setDoctorFilterList(applicableHeaderList[index].menuData);
    }
    setApplicableHeaderList([...applicableHeaderList]);
    setSelectedHeaderItem(val);
  };

  const openMobileMenuListQueue = (val) => {
    applicableHeaderListQueue.forEach((dh) => {
      dh.show_filter = false;
    });
    let index = applicableHeaderListQueue.findIndex(
      (list) => list.id === val.id
    );
    applicableHeaderListQueue[index].show_filter = true;
    if (val.filter_type === HEADER_FILTER_TYPE.CONSULTATION) {
      setConsultationList(applicableHeaderListQueue[index].menuData);
    }
    if (val.filter_type === HEADER_FILTER_TYPE.DOCTORNAME) {
      setDoctorFilterListQueue(applicableHeaderListQueue[index].menuData);
    }
    setApplicableHeaderListQueue([...applicableHeaderListQueue]);
    setSelectedHeaderItem(val);
  };

  const selectMobileFilterOptions = (item) => {
    let val = selected_header_item;
    let index = applicableHeaderList.findIndex((list) => list.id === val.id);
    let index1 = applicableHeaderList[index].menuData.indexOf(item);
    applicableHeaderList[index].menuData.map((data) => (data.selected = false));
    applicableHeaderList[index].menuData[index1].selected = true;
    setApplicableHeaderList([...applicableHeaderList]);
  };

  const selectMobileFilterOptionsQueue = (item) => {
    let val = selected_header_item;
    let index = applicableHeaderListQueue.findIndex(
      (list) => list.id === val.id
    );
    let index1 = applicableHeaderListQueue[index].menuData.indexOf(item);
    applicableHeaderListQueue[index].menuData[index1].selected =
      !applicableHeaderListQueue[index].menuData[index1].selected;
    setApplicableHeaderListQueue([...applicableHeaderListQueue]);
  };

  const handleApplyFilter = () => {
    let val = selected_header_item;
    let index = applicableHeaderList.findIndex((list) => list.id === val.id);
    let item = applicableHeaderList[index].menuData.filter(
      (menu) => menu.selected
    );
    appendFilterToUrl(item[0]);
    handleCloseMobFilter();
  };

  const handleApplyDownloadDateFilter = (selectedValue) => {
    let val = selected_header_item;
    let index = applicableHeaderList.findIndex((list) => list.id === val.id);
    if (
      applicableHeaderList[index].filter_type.toLowerCase() ===
      HEADERLIST.MOBILEDATE.toLowerCase()
    ) {
      let range = {};
      if (selectedValue !== "Date Range") {
        range = getDateByRanges(selectedValue);
      } else {
        range = {
          startDate: moment(selectionRange.startDate).format("YYYY-MM-DD"),
          endDate: moment(selectionRange.endDate).format("YYYY-MM-DD"),
        };
      }
      downloadCallback(range);
    }
    handleCloseMobFilter();
  };
  const handleApplyFilterQueue = () => {
    let val = selected_header_item;
    let index = applicableHeaderListQueue.findIndex(
      (list) => list.id === val.id
    );
    let item = applicableHeaderListQueue[index].menuData.filter(
      (menu) => menu.selected
    );
    if (item?.length > 0) {
      setSelectedQueueDoctorList(item);
      setSelectedQueueDoctor(item[0]);
      selectQueueDoctor(item[0]?.id);
      localStorage.setItem("lsSelectedQueueDoctor", JSON.stringify(item[0]));
      localStorage.setItem("lsSelectedQueueDoctorList", JSON.stringify(item));
    } else {
      setSelectedQueueDoctorList([]);
      setSelectedQueueDoctor({});
    }
    handleCloseMobFilterQueue();
  };

  const handleResetAllFilter = () => {
    handleCloseMobFilter();
    clearAllFilters();
  };

  const handleResetAllFilterQueue = () => {
    let val = selected_header_item;
    let index = applicableHeaderListQueue.findIndex(
      (list) => list.id === val.id
    );
    applicableHeaderListQueue[index].menuData.map(
      (data) => (data.selected = false)
    );
    setApplicableHeaderListQueue([...applicableHeaderListQueue]);
    setSelectedQueueDoctorList([]);
    localStorage.removeItem("lsSelectedQueueDoctor");
    localStorage.removeItem("lsSelectedQueueDoctorList");
    setSelectedQueueDoctor({});
    selectQueueDoctor("");
    handleCloseMobFilterQueue();
  };

  const handleChipDelete = (id) => {
    switch (id) {
      case APIFILTERLIST.CONSULTATION:
        removeQuery(history, location, [APIFILTERLIST.CONSULTATION]);
        removeQuery(history, location, [APIFILTERLIST.IS_PROCEDURE]);
        break;
      case APIFILTERLIST.STATUS:
        removeQuery(history, location, [APIFILTERLIST.STATUS]);
        break;
      case APIFILTERLIST.DOCTORNAME:
        removeQuery(history, location, [
          APIFILTERLIST.DOCTORNAME,
          APIFILTERLIST.DOCTOR_NAME,
        ]);
        break;
      case APIFILTERLIST.PRESCRIPTION_FILTER:
        removeQuery(history, location, [APIFILTERLIST.PRESCRIPTION_FILTER]);
        break;
      default:
        break;
    }
  };

  const clearAllFilters = () => {
    removeDashboardFilterFromLocalStorage();
    history.push({
      pathname: location.pathname,
      search: `?${APIFILTERLIST.CONSULTATION_TYPE}=${consultation_type}`,
    });
  };

  const handleCloseMobFilter = () => {
    setShowMobFilter(false);
    setShowDownloadMobFilter(false);
    applicableHeaderList.forEach((list) => {
      list.show_filter = false;
      list.menuData.forEach((menu) => {
        menu.selected = false;
      });
    });
    setApplicableHeaderList([...applicableHeaderList]);
    handleCloseMobileFilter();
  };

  const handleCloseMobFilterQueue = () => {
    setShowMobFilterQueue(false);
    applicableHeaderListQueue.forEach((list) => {
      list.show_filter = false;
    });
    setApplicableHeaderListQueue([...applicableHeaderListQueue]);
    handleCloseMobileFilterQueue();
  };

  const handleFilterSearch = (value) => {
    if (viewType === DASHBOARD_VIEW.LIST) {
      let index = dashboardHeaderList.findIndex(
        (list) => list.id === selected_header_item.id
      );
      if (
        dashboardHeaderList[index].filter_type ===
        HEADER_FILTER_TYPE.CONSULTATION
      ) {
        const filterData = consultationList.filter((data) =>
          data?.name?.toLowerCase().includes(value?.toLowerCase())
        );
        dashboardHeaderList[index].menuData = filterData;
        setDashboardHeaderList([...dashboardHeaderList]);
      }
      if (
        dashboardHeaderList[index].filter_type === HEADER_FILTER_TYPE.DOCTORNAME
      ) {
        const filteredData = doctorFilterList.filter(
          (doc) =>
            doc?.doctor_name?.toLowerCase()?.includes(value?.toLowerCase()) ||
            doc?.name?.toLowerCase()?.includes(value?.toLowerCase())
        );
        dashboardHeaderList[index].menuData = filteredData;
        setDashboardHeaderList([...dashboardHeaderList]);
      }
    } else if (viewType === DASHBOARD_VIEW.QUEUE) {
      let indexQueue = dashboardHeaderListQueue.findIndex(
        (list) => list.id === selected_queue_item.id
      );
      if (
        dashboardHeaderListQueue[indexQueue].filter_type ===
        HEADER_FILTER_TYPE.DOCTORNAME
      ) {
        const filteredData = doctorFilterListQueue.filter(
          (doc) =>
            doc.doctor_name?.toLowerCase()?.includes(value?.toLowerCase()) ||
            doc?.name?.toLowerCase()?.includes(value?.toLowerCase())
        );
        dashboardHeaderListQueue[indexQueue].menuData = filteredData;
        setDashboardHeaderListQueue([...dashboardHeaderListQueue]);
      }
    }
  };

  const DateTimeRangeRender = () => {
    return (
      <DateRangePicker
        ranges={[selectionRange]}
        startDatePlaceholder="From"
        endDatePlaceholder="To"
        showSelectionPreview={true}
        editableDateInputs={true}
        showPreview={false}
        staticRanges={[]}
        inputRanges={[]}
        dragSelectionEnabled={true}
        onChange={(item) => handleSelect(item.selection)}
        className="range-only-date m-auto"
      />
    );
  };

  const handleSelect = (ranges) => {
    setSelectionRange(ranges);
  };
  const handleApplyButton = () => {
    let val = selected_queue_item;
    let index = dashboardHeaderListQueue.findIndex(
      (list) => list.id === val.id
    );
    let item;
    if (dashboardHeaderListQueue[index].title === HEADERLIST.DOCTORNAME) {
      item = doctorFilterListQueue.filter((menu) => menu.selected);
    } else {
      item = dashboardHeaderListQueue[index].menuData.filter(
        (menu) => menu.selected
      );
    }
    if (item?.length > 0) {
      setSelectedQueueDoctorList(item);
      setSelectedQueueDoctor(item[0]);
      selectQueueDoctor(item[0]?.id);
      localStorage.setItem("lsSelectedQueueDoctorList", JSON.stringify(item));
      localStorage.setItem("lsSelectedQueueDoctor", JSON.stringify(item[0]));
    } else {
      setSelectedQueueDoctorList([]);
      setSelectedQueueDoctor({});
    }
    dashboardHeaderListQueue[index].show_filter = false;
    if (dashboardHeaderListQueue[index].title === HEADERLIST.DOCTORNAME) {
      dashboardHeaderListQueue[index].menuData = doctorFilterListQueue;
    }
    setDashboardHeaderListQueue([...dashboardHeaderListQueue]);
  };

  const selectChipHandler = (data) => {
    setSelectedQueueDoctor(data);
    selectQueueDoctor(data.doctor_id);
    localStorage.setItem("lsSelectedQueueDoctor", JSON.stringify(data));
  };

  const deleteChipHandler = (id) => {
    let index = dashboardHeaderListQueue.findIndex(
      (list) => list.title === HEADERLIST.DOCTORNAME
    );
    let index1 = dashboardHeaderListQueue[index].menuData.findIndex(
      (list) => list.doctor_id === id
    );
    dashboardHeaderListQueue[index].menuData[index1].selected = false;
    setDashboardHeaderListQueue([...dashboardHeaderListQueue]);
    let item = dashboardHeaderListQueue[index].menuData.filter(
      (menu) => menu.selected
    );
    if (item?.length > 0) {
      setSelectedQueueDoctorList(item);
      setSelectedQueueDoctor(item[0]);
      selectQueueDoctor(item[0]?.id);
      localStorage.setItem("lsSelectedQueueDoctorList", JSON.stringify(item));
    } else {
      setSelectedQueueDoctorList([]);
      setSelectedQueueDoctor({});
      selectQueueDoctor("");
      localStorage.removeItem("lsSelectedQueueDoctor");
      localStorage.removeItem("lsSelectedQueueDoctorList");
    }
  };

  const deleteMobChipHandler = (id) => {
    let val = selected_header_item;
    let index = applicableHeaderListQueue.findIndex(
      (list) => list.id === val.id
    );
    let index1 = applicableHeaderListQueue[index].menuData.findIndex(
      (list) => list.doctor_id === id
    );
    applicableHeaderListQueue[index].menuData[index1].selected = false;
    setApplicableHeaderListQueue([...applicableHeaderListQueue]);
    let item = applicableHeaderListQueue[index].menuData.filter(
      (menu) => menu.selected
    );
    if (item?.length > 0) {
      setSelectedQueueDoctorList(item);
      setSelectedQueueDoctor(item[0]);
      localStorage.setItem("lsSelectedQueueDoctorList", JSON.stringify(item));
      selectQueueDoctor(item[0]?.id);
    } else {
      setSelectedQueueDoctorList([]);
      setSelectedQueueDoctor();
      localStorage.removeItem("lsSelectedQueueDoctor");
      localStorage.removeItem("lsSelectedQueueDoctorList");
    }
  };

  const handleResetButton = () => {
    let val = selected_queue_item;
    let index = dashboardHeaderListQueue.findIndex(
      (list) => list.id === val.id
    );
    dashboardHeaderListQueue[index].menuData.map(
      (data) => (data.selected = false)
    );
    dashboardHeaderListQueue[index].show_filter = false;
    setDashboardHeaderListQueue([...dashboardHeaderListQueue]);
    setSelectedQueueDoctorList([]);
    localStorage.removeItem("lsSelectedQueueDoctor");
    localStorage.removeItem("lsSelectedQueueDoctorList");
    setSelectedQueueDoctor({});
    selectQueueDoctor("");
  };

  const handleCloseQueue = (item) => {
    let index = dashboardHeaderListQueue.findIndex(
      (list) => list.id === item.id
    );
    dashboardHeaderListQueue[index].show_filter = false;
    if (dashboardHeaderListQueue[index].title === HEADERLIST.DOCTORNAME) {
      dashboardHeaderListQueue[index].menuData = doctorFilterListQueue;
    }
    setDashboardHeaderListQueue([...dashboardHeaderListQueue]);
  };

  // <===

  // Create UI ==>

  const displayDashboardAppointmentsViewMainContent = () => {
    let headerList = dashboardHeaderList.filter(
      (list) =>
        list.applicable_roles.indexOf(user_type) !== -1 ||
        list.applicable_roles.indexOf(doctorRole) !== -1
    );
    let arr = headerList.map((item) => {
      return item["title"];
    });

    return (
      <>
        <div
          className={
            "dashboard-appointments-view-table " +
            (window.innerWidth > 767 ? "ml-3 mt-4 mr-3" : "ml-3 mt-2 mr-3")
          }
        >
          {displayStatusCountHeader()}
          {consultation_type === CONSULTATIONTYPE.INCLINIC &&
            displayPaymentMethodHeader()}
          {window.innerWidth > 767 && (
            <DashboardAppointmentsViewTableHeader
              user_type={user_type}
              doctorRole={doctorRole}
              headerList={headerList}
              consultation_type={consultation_type}
              selectedStatusCard={selectedStatusCard}
              selectedFilters={selectedFilters}
              displayNormalFilterList={displayNormalFilterList}
              openMenuList={openMenuList}
            />
          )}
          {!contentLoading ? (
            dashboardAppointmentsData?.length == 0 &&
            !showModalForScheduleFollowUp ? (
              displayNoDataFound()
            ) : (
              <DashboardAppointmentsViewTableCell
                user_type={user_type}
                doctorRole={doctorRole}
                user_id={user_id}
                clinic_id={clinic_id}
                staff_id={staff_id}
                page_no={page_no}
                arr={arr}
                app_start_date={app_start_date}
                appointmentsData={dashboardAppointmentsData}
                selected_doctor={selected_doctor}
                checkedInAppnt={checkedInAppnt}
                doctorIds={doctorIds}
                doctorClinicAssociation={doctorClinicAssociation}
                refreshAppointmentsMethod={handleRefreshApi}
                onRescheduleAppnt={onRescheduleAppnt}
                callNextAppointmentWidget={callNextAppointmentWidget}
                appointmentsApi={callDashboardAppointmentsApi}
                showModalForScheduleFollowUp={showModalForScheduleFollowUp}
                setShowModalForScheduleFollowUp={
                  setShowModalForScheduleFollowUp
                }
                isUhidEnabled={isUhidEnabled}
              />
            )
          ) : null}
        </div>
      </>
    );
  };

  const displayDashboardAppointmentsQueueContent = () => {
    let headerList = dashboardHeaderListQueue.filter(
      (list) =>
        list.applicable_roles.indexOf(user_type) !== -1 ||
        list.applicable_roles.indexOf(doctorRole) !== -1
    );
    let arr = headerList.map((item) => {
      return item["title"];
    });
    return (
      <>
        <div
          className={
            "dashboard-appointments-view-table " +
            (window.innerWidth > 767 ? "ml-3 mt-4 mr-3" : "ml-3 mt-2 mr-3")
          }
        >
          {displayStatusCountHeaderQueue()}
          {consultation_type === CONSULTATIONTYPE.INCLINIC &&
            displayPaymentMethodHeaderQueue()}
          {window.innerWidth > 767 && (
            <DashboardAppointmentsTableQueueHeader
              user_type={user_type}
              doctorRole={doctorRole}
              headerList={headerList}
              consultation_type={consultation_type}
              selectedStatusCard={selectedStatusCard}
              selectedFilters={selectedQueueDoctorList}
              selectedQueueDoctor={selectedQueueDoctor}
              displayNormalFilterList={displayNormalFilterListQueue}
              openMenuList={openQueueMenuList}
              selectChipHandler={selectChipHandler}
              deleteChipHandler={deleteChipHandler}
            />
          )}
          {!selectedQueueDoctor?.doctor_id || !selectedQueueDoctor?.name ? (
            displaySelectDoctorQueue()
          ) : selectedQueueDoctor?.doctor_id &&
            !showModalForScheduleFollowUp &&
            appointmentListQueueView?.length == 0 ? (
            displayNoDataQueue()
          ) : (
            <DashboardAppointmentsViewTableCell
              user_type={user_type}
              doctorRole={doctorRole}
              user_id={user_id}
              clinic_id={clinic_id}
              staff_id={staff_id}
              page_no={page_no}
              arr={arr}
              app_start_date={app_start_date}
              appointmentsData={appointmentListQueueView}
              selected_doctor={selected_doctor}
              checkedInAppnt={checkedInAppnt}
              doctorIds={doctorIds}
              doctorClinicAssociation={doctorClinicAssociation}
              refreshAppointmentsMethod={handleRefreshApi}
              onRescheduleAppnt={onRescheduleAppnt}
              callNextAppointmentWidget={callNextAppointmentWidget}
              appointmentsApi={callDashboardAppointmentsApi}
              showModalForScheduleFollowUp={showModalForScheduleFollowUp}
              setShowModalForScheduleFollowUp={setShowModalForScheduleFollowUp}
              isUhidEnabled={isUhidEnabled}
            />
          )}
        </div>
      </>
    );
  };

  const displayNoDataFound = () => {
    return !contentLoading ? (
      <>
        <NoDataComponent
          image={NoDataFound}
          heading={"No Record Found"}
          message={"There are no appointments available"}
        />
      </>
    ) : (
      <div className="text-center">
        <img src={Loader} alt="loading.." />
      </div>
    );
  };

  const displayStatusCountHeader = () => {
    return (
      <div className="status-count-header">
        {statusCountHeader.map((st, indS) => (
          <div
            key={indS}
            className="Summary-count"
            style={{
              backgroundColor: st.selected ? "#E4F3F7" : "",
              borderBottom: st.selected ? "0" : "",
            }}
            onClick={() => handleStatusCard(st.value)}
          >
            <TitleSubtitleCard title={st.name} subtitle={st.count} />
            {st.selected && (
              <div className="d-flex justify-content-center">
                <i
                  className="fa fa-caret-down"
                  style={{
                    position: "absolute",
                    color: "#E4F3F7",
                    fontSize: "18px",
                  }}
                ></i>
              </div>
            )}
          </div>
        ))}
      </div>
    );
  };

  const displayStatusCountHeaderQueue = () => {
    return (
      <div className="status-count-header">
        {statusCountHeaderQueue.map((st, indS) => (
          <div
            key={indS}
            className="Summary-count"
            style={{
              backgroundColor: st.selected && !st.disabled ? "#E4F3F7" : "",
              borderBottom: st.selected && !st.disabled ? "0" : "",
            }}
            onClick={() => handleStatusCardQueue(st.value)}
          >
            <TitleSubtitleCard
              title={st.name}
              subtitle={st.count}
              disabled={st.disabled}
            />
            {st.selected && !st.disabled && (
              <div className="d-flex justify-content-center">
                <i
                  className="fa fa-caret-down"
                  style={{
                    position: "absolute",
                    color: "#E4F3F7",
                    fontSize: "18px",
                  }}
                ></i>
              </div>
            )}
          </div>
        ))}
      </div>
    );
  };

  const displayPaymentMethodHeader = () => {
    const showPartialPaymentOption = clinic_id;

    const filteredPaymentMethods = paymentMethodHeader.filter((pay) => {
      if (showPartialPaymentOption) {
        return true;
      } else {
        return pay.name !== "Partial Payment";
      }
    });

    return (
      <div className="payment-method-header">
        <span className="payment-method-title">Payment Method: </span>
        <div style={{ display: window.innerWidth > 767 ? "flex" : "block" }}>
          {filteredPaymentMethods.map((pay, indP) => (
            <RadioButtonWithText
              key={indP}
              data={pay}
              text={
                pay.name + (pay.value !== "all" ? " (" + pay.count + ")" : "")
              }
              value={pay.value}
              selected={pay.selected}
              style={{ fontWeight: pay.selected ? "bold" : "" }}
              handleChange={handlePaymentMethod}
            />
          ))}
        </div>
      </div>
    );
  };

  const displayPaymentMethodHeaderQueue = () => {
    const showPartialPaymentOptionQueue = clinic_id;

    const filteredPaymentMethodsQueue = paymentMethodHeaderQueue.filter(
      (pay) => {
        if (showPartialPaymentOptionQueue) {
          return true;
        } else {
          return pay.name !== "Partial Payment";
        }
      }
    );

    return (
      <div className="payment-method-header">
        <span className="payment-method-title">Payment Method: </span>
        <div style={{ display: window.innerWidth > 767 ? "flex" : "block" }}>
          {filteredPaymentMethodsQueue.map((pay, indP) => (
            <RadioButtonWithText
              key={indP}
              data={pay}
              text={
                pay.name + (pay.value !== "all" ? " (" + pay.count + ")" : "")
              }
              value={pay.value}
              selected={pay.selected}
              style={{ fontWeight: pay.selected ? "bold" : "" }}
              handleChange={handlePaymentMethodQueue}
            />
          ))}
        </div>
      </div>
    );
  };

  const displayNormalFilterList = (val) => {
    if (val.filter_type !== HEADER_FILTER_TYPE.DATE) {
      return (
        <ClickAwayListener onClickAway={() => handleClose(val)}>
          <div>
            <FilterMenuList
              menuItemList={val.menuData}
              toggleItems={toggleItems}
              handleFilterSearch={handleFilterSearch}
              show_filter_searchbar={val?.show_filter_searchbar}
              placeholderForSearch={val?.placeholderForSearch}
            />
          </div>
        </ClickAwayListener>
      );
    } else {
      return (
        <ClickAwayListener onClickAway={() => handleClose(val)}>
          <div>
            <DatePicker
              closeDatePicker={closeDatePicker}
              applyRange={applyRange}
            />
          </div>
        </ClickAwayListener>
      );
    }
  };

  const displayNormalFilterListQueue = (val) => {
    return (
      <ClickAwayListener onClickAway={() => handleCloseQueue(val)}>
        <div>
          <FilterMenuList
            menuItemList={val.menuData}
            toggleItems={toggleQueueItems}
            handleFilterSearch={handleFilterSearch}
            show_filter_searchbar={val?.show_filter_searchbar}
            isMultiSelect={val?.isMultiSelect}
            showApplyResetBtn={val?.showApplyResetBtn}
            handleApplyButton={handleApplyButton}
            handleResetButton={handleResetButton}
            placeholderForSearch={val?.placeholderForSearch}
          />
        </div>
      </ClickAwayListener>
    );
  };

  const displaySelectedFilters = () => {
    return (
      <div className="dashborad-appointments-filter-chips d-flex">
        {selectedFilters.map((sl, ind) => (
          <div className="deletable-chip" key={ind}>
            <CustomisedChip
              label={sl.label}
              id={sl.id}
              deletable={true}
              deleteHandler={handleChipDelete}
            />
          </div>
        ))}
        {selectedFilters.length > 0 && (
          <div className="clear-all-chip">
            <CustomisedChip
              label={SELECTEDFILTERTITLE.CLEARALL}
              id={SELECTEDFILTERTITLE.CLEARALL}
              clickHandler={clearAllFilters}
            />
          </div>
        )}
      </div>
    );
  };

  const displaySelectedFiltersQueue = () => {
    return (
      <div className="dashborad-appointments-filter-chips d-flex">
        {selectedQueueDoctorList.map((sl, ind) => (
          <div className="deletable-chip" key={ind}>
            <MultiSelectChips
              label={sl.label}
              id={sl.id}
              selected_id={selectedQueueDoctor?.doctor_id}
              deletable={true}
              deleteHandler={deleteMobChipHandler}
              clickHandler={selectChipHandler}
              chipdata={sl}
            />
          </div>
        ))}
      </div>
    );
  };

  const displaySelectDoctorQueue = () => {
    return !contentLoading ? (
      <>
        <NoDataComponent
          image={SelectDoctor}
          message={"You can select the doctors to load their appointments."}
        />
      </>
    ) : (
      <div className="text-center">
        <img src={Loader} alt="loading.." />
      </div>
    );
  };

  const displayNoDataQueue = () => {
    return !contentLoading ? (
      <>
        <NoDataComponent
          image={NoDataFound}
          message={"There are no appointments available for "}
          text={selectedQueueDoctor?.name}
        />
      </>
    ) : (
      <div className="text-center">
        <img src={Loader} alt="loading.." />
      </div>
    );
  };

  // <===

  return (
    <>
      {window.innerWidth < 767 &&
        selectedFilters.length > 0 &&
        displaySelectedFilters()}
      {window.innerWidth < 767 &&
        viewType == DASHBOARD_VIEW.QUEUE &&
        selectedQueueDoctorList?.length > 0 &&
        displaySelectedFiltersQueue()}
      {viewType == DASHBOARD_VIEW.LIST &&
        displayDashboardAppointmentsViewMainContent()}
      {viewType == DASHBOARD_VIEW.QUEUE &&
        displayDashboardAppointmentsQueueContent()}
      {showMobileFilter && (
        <CustomisedMobileFilter
          showMobileFilter={showMobFilter}
          menuList={applicableHeaderList}
          selectedMenu={selected_header_item}
          handleClose={handleCloseMobFilter}
          openMobileMenuList={openMobileMenuList}
          handleMobileSelectedItem={handleMobileSelectedItem}
          selectMobileFilterOptions={selectMobileFilterOptions}
          handleApplyFilter={handleApplyFilter}
          handleResetAllFilter={handleResetAllFilter}
          handleFilterSearch={handleFilterSearch}
          placeholderForSearch={getPlaceholder()}
        />
      )}
      {showDownloadMobileFilter && (
        <MobileFilterWithDatePicker
          showMobileFilter={showDownloadMobFilter}
          menuList={applicableHeaderList}
          selectedMenu={selected_header_item}
          handleClose={handleCloseMobFilter}
          openMobileMenuList={openMobileMenuList}
          handleMobileSelectedItem={handleMobileSelectedItem}
          selectMobileFilterOptions={selectMobileFilterOptions}
          handleApplyFilter={handleApplyDownloadDateFilter}
          handleResetAllFilter={handleResetAllFilter}
          handleFilterSearch={handleFilterSearch}
          DateTimeRangeRender={DateTimeRangeRender}
        />
      )}
      {showMobileFilterQueue && (
        <CustomisedMobileFilter
          showMobileFilter={showMobFilterQueue}
          menuList={applicableHeaderListQueue}
          selectedMenu={selected_header_item}
          handleClose={handleCloseMobFilterQueue}
          openMobileMenuList={openMobileMenuListQueue}
          handleMobileSelectedItem={handleMobileSelectedItem}
          selectMobileFilterOptions={selectMobileFilterOptionsQueue}
          handleApplyFilter={handleApplyFilterQueue}
          handleResetAllFilter={handleResetAllFilterQueue}
          handleFilterSearch={handleFilterSearch}
          placeholderForSearch={getPlaceholder()}
        />
      )}
    </>
  );
};

export default DashboardAppointmentsViewTable;
